import classNames from "classnames";
import React from "react";
import "./page.headline.component.scss";
import BackButton from "components/general.compoenents/back.button.component/back.button.component";
import Row from "components/general.compoenents/row.component/row.component";
import Headline from "components/text.components/headline.component/headline.component";

interface PageHeadlineProps {
  title?: string;
  actions?: JSX.Element | JSX.Element[];
  children?: React.ReactNode | React.ReactNode[];
  className?: string;
  classNameActions?: string;
  showBackButton?: boolean;
  rootPath?: string;
}

const PageHeadline = ({
  title,
  children,
  actions,
  className,
  classNameActions,
  showBackButton = false,
  rootPath,
}: PageHeadlineProps): JSX.Element => {
  const pageHeadlineClassName = classNames(
    {
      "page-headline-container": true,
    },
    className
  );

  const pageHeadlineActionsClassName = classNames(
    {
      "page-headline-left-actions": true,
    },
    classNameActions
  );

  const _buildBackButton = (): JSX.Element => {
    return <BackButton className="mr-20" rootPath={rootPath} />;
  };

  return (
    <Row
      className={pageHeadlineClassName}
      alignItems="center"
      justifyContent="space-between"
    >
      <Row alignItems="center" className={pageHeadlineActionsClassName}>
        {showBackButton && _buildBackButton()}
        {title != null && <Headline>{title}</Headline>}
        {children}
      </Row>
      {actions && (
        <Row
          className="page-headline-container-actions"
          justifyContent="flex-end"
        >
          {actions}
        </Row>
      )}
    </Row>
  );
};

export default PageHeadline;
